<div class="peak-sales-filter">
  <div
    *ngIf="
      loading &&
      ((activePanel === panel.key && refreshCurrentPanel) ||
        activePanel !== panel.key)
    "
  >
    <va-custom-skeleton
      [customSkeletonConfig]="customSkeletonConfig"
    >
    </va-custom-skeleton>
  </div>
  <ng-container *ngIf="!loading || (activePanel == panel.key && !refreshCurrentPanel) && data">
    <div class="currency-warning-label" *ngIf="!data.sale_currency">
      Please change currency from base to some other value.
    </div>
    <div class="header">
      <label
        nz-checkbox
        class="max-sales-label"
        [disabled]="!data.sale_currency"
        [ngModel]="facetFilter.include_max_sale"
        (ngModelChange)="onMaxSaleChange($event)"
        title="Include Max Sales"
      >
        <span class="option">Include Max Sales</span>
        <va-icon
          size="small"
          name="info-circle"
          class="info-icon"
        ></va-icon>
      </label>
      <!-- <va-button
        state="primary"
        btnType="text"
        size="medium"
        class="reset-btn"
        (click)="onChange.emit({})"
        [isDisabled]="!data.sale_currency"
      >
        Reset
      </va-button> -->
    </div>
    <app-pharma-slider-filter
      label="Amount"
      [showLabel]="true"
      [min]="data.sale_min"
      [max]="data.sale_max"
      [selectedMin]="(facetFilter && facetFilter.sale_selected_min) || data.sale_min || '' "
      [selectedMax]="(facetFilter && facetFilter.sale_selected_max) || data.sale_max || '' "
      [magnitude]="data.sale_magnitude"
      [currency]="data.sale_currency"
      [isDisabled]="!data.sale_currency"
      [valueFormatter]="amountFormatter"
      (onSelectionChange)="onPeakSalesChange($event)"
    ></app-pharma-slider-filter>
    <div class="divider"></div>
    <app-pharma-slider-filter
      label="Peak Year Range"
      [showLabel]="true"
      [min]="data.year_min"
      [max]="data.year_max"
      step="1"
      [selectedMin]="(facetFilter && facetFilter.year_selected_min) || data.year_min || '' "
      [selectedMax]="(facetFilter && facetFilter.year_selected_max) || data.year_max || '' "
      [isDisabled]="!data.sale_currency"
      (onSelectionChange)="onPeakYearChange($event)"
    ></app-pharma-slider-filter>

    <!-- <ng-template #amountFormatter>
      
    </ng-template> -->
  </ng-container>
  <!-- <ng-container *ngIf="!dataExists(data)">
    no data
  </ng-container> -->
</div>